module.exports = __webpack_public_path__ + "static/img/10.6c81fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/10.jpg
// module id = VBg6
// module chunks = 29